import { Grid } from "@mui/material";
import CreateZone from "./ShippingActions/CreateZone";
const ShippingZoneActions = ({
  isAdmin,
  isStaff,
  loading,
  error,
  filters,
  pagination,
  communeOptions,
  courierOptions,
  adminOptions,
  refetchShippingZones,
  createZone,
  updateZone,
  regions,
  loadingRegions,
  fetchRegions,
}) => {
  return (
    <Grid container>
      <CreateZone
        createZone={createZone}
        isAdmin={isAdmin}
        isStaff={isStaff}
        error={error}
        loading={loading}
        communeOptions={communeOptions}
        courierOptions={courierOptions}
        adminOptions={adminOptions}
        regions={regions}
        loadingRegions={loadingRegions}
        fetchRegions={fetchRegions}
      />
    </Grid>
  );
};

export default ShippingZoneActions;
